/**
 * Product paths on www, member app at /app, Talk at /talk.
 * Helpers keep navigation same-origin (no app./talk. subdomains).
 */

export const SITE_ORIGIN = 'https://www.getbyonco.com';

export function isMemberAppPath(pathname = '') {
  const p = String(pathname || '');
  return p === '/app' || p.startsWith('/app/');
}

export function isOncoAgentAppPath(pathname = '') {
  const p = String(pathname || '');
  return p === '/oncoagent/app' || p.startsWith('/oncoagent/app/');
}

export function isTalkPath(pathname = '') {
  const p = String(pathname || '').replace(/\/+$/, '') || '/';
  return p === '/talk';
}

/** Strip leading /app for relative member segments. */
export function stripAppPrefix(pathname = '/') {
  const raw = String(pathname || '/');
  if (raw === '/app' || raw === '/app/') return '/';
  if (raw.startsWith('/app/')) {
    const rest = raw.slice(4);
    return rest.startsWith('/') ? rest : `/${rest}`;
  }
  return raw.startsWith('/') ? raw : `/${raw}`;
}

/** Path used inside the member SPA (NavLink / navigate): /app, /app/settings, … */
export function memberPath(path = '/') {
  const rest = stripAppPrefix(path);
  if (rest === '/') return '/app';
  return `/app${rest}`;
}

/** Same-origin URL for the member app. */
export function appUrl(path = '/') {
  return memberPath(path);
}

/** Same-origin URL for Talk. */
export function talkUrl(path = '/') {
  if (!path || path === '/' || path === '/talk' || path === '/talk/') return '/talk';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (normalized.startsWith('/talk')) return normalized;
  return `/talk${normalized}`;
}

/** Marketing / auth path (same origin). */
export function wwwUrl(path = '/') {
  if (!path || path === '/') return '/';
  return path.startsWith('/') ? path : `/${path}`;
}

/** Navigate within the SPA, or assign if given an absolute URL. */
export function goProduct(urlOrPath, navigate) {
  if (!urlOrPath) return;
  if (/^https?:\/\//i.test(urlOrPath)) {
    if (typeof window !== 'undefined') window.location.assign(urlOrPath);
    return;
  }
  if (typeof navigate === 'function') {
    navigate(urlOrPath);
    return;
  }
  if (typeof window !== 'undefined') window.location.assign(urlOrPath);
}

/** After login/register: land on the requested path. */
export function finishAuthRedirect(navigate, redirectPath) {
  const target = redirectPath || '/app';
  goProduct(target, navigate);
}

export function authUrlWithRedirect(returnPath) {
  const redirect = returnPath || '/app';
  return `/authentication?redirect=${encodeURIComponent(redirect)}`;
}
